import { combineReducers } from 'redux';
import file from './file';
import user from './user';
import mode from './mode';
import version from './version';
import product from './product';

export default combineReducers({ file, user, mode, version, product })
